export class InvalidPropertyType extends Error {
	constructor(value: number | string, method: string) {
		super(
			`Invalid property type. Property type is equal to "${value}" in "${method}()" function. Property type must be "OLD" | "OLD_WITH_WORKS" | "LAND_AND_CONSTRUCTION"| "NEW"`
		);
	}
}
